<template>
  <!-- side menu mobile -->
  <div
    class="cabinet-console-menu-mobile"
    :class="{ 'cabinet-console-menu-mobile-collapsed': !expanded }"
  >
    <!-- Logos unidos al menu lateral -->
    <div v-if="region === 'forex'">
      <img src="/assets/images/logo_tradeview_white.svg" class="logo" v-if="expanded" />
      <img src="/assets/images/logo_tradeview_white.svg" class="collapsed-logo" v-else />
    </div>
    <div v-else-if="region === 'mena'">
      <img src="/assets/images/logo_tradeview-red-white.svg" class="logo" v-if="expanded" />
      <img src="/assets/images/logo_tradeview-red-white.svg" class="collapsed-logo" v-else />
    </div>
    <div v-else-if="region === 'uk'">
      <img src="/assets/images/tradeview-uk.png" class="logo" v-if="expanded" />
      <img src="/assets/images/tradeview-uk.png" class="collapsed-logo" v-else />
    </div>
    <div v-else-if="region === 'latam'">
      <img src="/assets/images/logo_tradeview_v2_white.svg" class="logo" v-if="expanded" />
      <img src="/assets/images/logo_tradeview_v2_white.svg" class="collapsed-logo" v-else />
    </div>
    <div v-else>
      <img src="/assets/images/logo_tradeview_full_dark.svg" class="logo" v-if="expanded" />
      <img src="/assets/images/logo_tradeview_full_dark.svg" class="collapsed-logo" v-else />
    </div>

    <!-- Collapse arrow and theme switch -->
    <div class="menu-row">
      <button class="collapse-menu" @click="collapseMenu">
        <img src="/assets/images/cabinet_arrow_left.svg" alt />
      </button>
      <!-- switch themes -->
      <CustomSwitch ref="themeSwitch" v-if="expanded" v-model:checked="themeDark"></CustomSwitch>
    </div>

    <!-- Menu Items -->
    <div class="menu" :key="selectedIndex">
      <div class="menu-item" v-for="item in menuItems" :key="item.idx">
        <!-- Item component-->
        <div v-if="region === 'uk'">
          <ConsoleMenuItem
            v-if="item.show"
            :idx="item.idx"
            :activeAccount="activeAccount"
            :selected="item.selected"
            :icon="item.icon"
            :iconBlue="item.iconBlue"
            :iconDisabled="item.iconDisabled"
            :optionDisabled="item.optionDisabled"
            :label="item.name"
            :show-children="item.showChildren"
            :collapsed="!expanded"
            @clicked="menuItemSelected"
          ></ConsoleMenuItem>
        </div>

        <div v-else-if="region === 'forex'">
          <ConsoleMenuItem
            v-if="item.show"
            :idx="item.idx"
            :activeAccount="activeAccount"
            :selected="item.selected"
            :icon="item.icon"
            :iconBlack="item.iconBlack"
            :iconDisabled="item.iconDisabled"
            :optionDisabled="item.optionDisabled"
            :label="item.name"
            :show-children="item.showChildren"
            :collapsed="!expanded"
            @clicked="menuItemSelected"
          ></ConsoleMenuItem>
        </div>

        <div v-else-if="region === 'mena'">
          <ConsoleMenuItem
            v-if="item.show"
            :idx="item.idx"
            :activeAccount="activeAccount"
            :selected="item.selected"
            :icon="item.icon"
            :iconBlack="item.iconRed"
            :iconDisabled="item.iconDisabled"
            :optionDisabled="item.optionDisabled"
            :label="item.name"
            :show-children="item.showChildren"
            :collapsed="!expanded"
            @clicked="menuItemSelected"
          ></ConsoleMenuItem>
        </div>
      </div>
      <div class="menu-item">
        <ConsoleMenuItem
          :idx="0"
          :selected="false"
          :icon="iconLogout"
          :label="this.$t('consoleHeader.logout')"
          :show-children="null"
          :collapsed="!expanded"
          @clicked="attemptLogout"
        ></ConsoleMenuItem>

        <div class="label-lang">{{ $t("consoleHeader.selectlang") }}</div>
        <SelectLanguage
          class="cabinet-login-language"
          v-model="language"
        >dssdf</SelectLanguage>
      </div>
    </div>

    <Modal v-if="showDialog" @close="showDialog = false" dialog-style="logout-modal">
      <template #header>
        <h3>Confirm</h3>
      </template>
      <template #body>
        <p>Are you sure you want to logout?</p>
      </template>
      <template #footer>
        <div>
          <button @click="logout" class="red-button">Yes</button>
          <button @click="showDialog = false" class="red-button">No</button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
/* eslint-disable */

// import menu from "../../menu.js";
// import menuLight from "../../menu-light.js";
import { Auth } from 'aws-amplify';
import CustomSwitch from "@/components/CustomSwitch";
import ConsoleMenuItem from "@/components/cabinet/ConsoleMenuItem";
import Modal from "@/components/Modal";
import store from "@/store"
import router from "@/router"
import { updatePreferences } from "@/plugins/authUtils";
import { Logger } from "aws-amplify";
import menu from "@/menu"
import menuLight from "@/menu-light"
import { getCurrentInstance, onMounted, onUnmounted, ref, watch } from "@vue/runtime-core";
import SelectLanguage from "@/components/SelectLanguage";



const logger = new Logger("main")
export default {
  name: "ConsoleMenuMobile",
  components: {
    CustomSwitch,
    ConsoleMenuItem,
    Modal,
    SelectLanguage,
  },
  props: ['expanded'],
  emits: ['expand'],

  data() {
    return {
      language: this.$i18n.locale,
    };
  },

  mounted() {
    this.language = this.$i18n.locale;
  },

  watch: {
    language() {
      this.changeLocale(this.language);
    },
  },

  setup(props, { emit }) {
    let themeDark = ref()
    let menuItems = ref([])
    let selectedIndex = ref(0)
    let imgLogo = ref('/assets/images/logo_tradeview_full_dark.svg')
    let menuIcons = ref([])
    let showDialog = ref(false)
    let iconLogout = ref(null)
    const themeSwitch = ref(null)
    const internalInstance = getCurrentInstance()
    const emitter = internalInstance.appContext.config.globalProperties.emitter
    const region = ref(process.env.VUE_APP_CABINET_ORIGIN);

    onMounted(() => {
      let userInfo = localStorage.getItem("activeAccount")
      let optionMenu = menu.items
      /*if (userInfo === 'ACTIVE' && optionMenu[0].name == 'Applications') {
        optionMenu.splice(0, 1)
      }*/
      menuIcons.value = menu.items
      menuItems.value = []
      buildMenu(menu.items, 0, 0, 0, true)
      if (menuItems.value.length > 0)
        menuItems.value[0].selected = true  //  TODO: should be based on the url!!!

      setTheme()

      emitter.on('preferencesUpdated', () => {
        setTheme()
      })
    })

    onUnmounted(() => {
      emitter.off('preferencesUpdated')
    })

    const setTheme = () => {
      if (store.state.preferences) {
        let theme = store.state.preferences.theme

        let htmlElement = document.documentElement
        menuIcons.value = []
        switch (theme) {
          case 'DARK':
            menuItems.value = []
            imgLogo.value = '/assets/images/logo_tradeview_full_dark.svg'
            let userInfo = localStorage.getItem("activeAccount")
            let optionMenu = menuLight.items
            /*if (userInfo === 'ACTIVE' && optionMenu[0].name == 'Applications') {
              optionMenu.splice(0, 1)
            }*/
            buildMenu(menuLight.items, 0, 0, 0, true)
            htmlElement.setAttribute('theme', 'dark')
            themeDark.value = true
            iconLogout.value = 'icon-cabinet-logout-white.svg'
            break
          case 'LIGHT':
            menuItems.value = []
            imgLogo.value = '/assets/images/logo_tradeview_full_dark.svg'
            buildMenu(menu.items, 0, 0, 0, true)
            htmlElement.setAttribute('theme', 'light')
            themeDark.value = false
            iconLogout.value = 'icon-cabinet-logout-gray.svg'
            break
          default:
            logger.error('unknown html attribute: ', htmlElement)
            break
        }

        if (themeSwitch.value)
          themeSwitch.value.set(themeDark.value)

      }
    }

    const buildMenu = (items, i, k, parent, show) => {
      let userInfo = localStorage.getItem("activeAccount")
      items[0].selected = true;
      for (var j in items) {
        if (userInfo === 'ACTIVE' && items[0].name === 'Accounts') {
          items[j].optionDisabled = false
        }
        items[0].optionDisabled = false
        if (userInfo === 'ACTIVE') {
          items[j].optionDisabled = false
        } else {
          items[j].optionDisabled = true
        }
      }

      let item = items[i]

      item.idx = k
      item.show = show
      item.parent = parent
      item.selected = false
      if (item.children == null || item.children.length === 0) {
        item.showChildren = null
      } else {
        item.showChildren = false
      }
      menuItems.value.push(item)

      if (item.children != null && item.children.length > 0)
        k = buildMenu(item.children, 0, k + 1, k, false)

      if (items.length > i + 1)
        k = buildMenu(items, i + 1, k + 1, parent, show)

      return k
    }

    const collapseMenu = () => {
      emit('expand')
    }

    const menuItemSelected = (idx) => {
      let userInfo = store.state.user

      if (userInfo !== null) {
        selectedIndex.value = idx
        if (menuItems.value[idx].showChildren != null) {
          menuItems.value[idx].showChildren = !menuItems.value[idx].showChildren
          menuItems.value.forEach((item) => {
            if (item.parent === idx) {
              item.show = !item.show
            } else {
              if (item.parent !== 0)
                item.show = false
            }
          })
        } else {
          menuItems.value.forEach((item, i) => {
            item.selected = (i === idx)
          })
          router.push(menuItems.value[idx].url).catch(err => {
          })
        }
      } else {
          router.replace({
            path: '/cabinet/console/applications'
          })
      }

      collapseMenu()
    }

    watch(themeDark, () => {
      let preferences = store.state.preferences
      let userInfo = store.state.user

      preferences.theme = themeDark.value ? 'DARK' : 'LIGHT'
      emitter.emit('preferencesUpdated')
      if (preferences) {
        preferences.theme = themeDark.value ? 'DARK' : 'LIGHT'

        if (userInfo !== null) {
          const _headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + store.state.token,
            // 'X-Api-Key': process.env.VUE_APP_X_API_KEY
          }

          const _url = process.env.VUE_APP_CABINET_V2_API_HOST_PREFERENCES + '/preferences/user'
          const _body = { "theme": preferences.theme }
          axios({ method: 'post', url: _url, data: _body, headers: _headers }).then((result) => {
              console.log('preference saved')
            }).catch((error) => { logger.error(error) })
        }
      }
    })

    const attemptLogout = () => {
      // console.log('attempting logout...')
      // this.$refs['logout-modal'].show();
      showDialog.value = true

      // this.$router.push('/logout').catch(err => {});;
    }

    const logout = async () => {
      // console.log('logging out...')
      localStorage.removeItem('storedAccounts');
      localStorage.removeItem('typeAccount');
      localStorage.removeItem('activeAccount');
      localStorage.removeItem('Accountsdm5');
      localStorage.removeItem('Accountsdm4');
      localStorage.removeItem('form_procces');

      try {
        await Auth.signOut()
        // console.log('logout successful!')
        router.replace('/login').catch(err => {
        });
        showDialog.value = false
      } catch (error) {
        // console.log('error signing out: ', error)
        showDialog.value = false
      }
    }

    return {
      collapseMenu,
      menuItemSelected,

      themeSwitch,
      themeDark,
      menuItems,
      selectedIndex,
      iconLogout,
      imgLogo,
      menuIcons,
      region,

      logout,
      attemptLogout,
      showDialog
    }
  }
}
</script>
